import React from "react";

interface ShimmerProps {
  className?: string;
  width?: string;
  height?: string;
}

const Shimmer: React.FC<ShimmerProps> = ({
  className = "",
  width = "w-full",
  height = "h-full",
}) => {
  return (
    <div
      className={`${width} ${height} ${className} bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-shimmer`}
    />
  );
};

export default Shimmer;
